<template>
    <div class="gapp_post__post-container">

        <div 
            v-if="typeof post.featuredImage.mediaItemUrl != 'undefined'" 
            class="gapp_post__post-image-container"
            :style="{ backgroundImage:'url(' + post.featuredImage.mediaItemUrl + ')' }">

            <a :href="post.link"></a>    
        </div>

        <div class="gapp_post__post-content">
            <h3 class="gapp_post__post-heading">
                 <a :href="post.link">{{ cleanTitle }}</a> 
            </h3>

            <div class="gapp_post__post-meta">
                {{ post.date | moment("LL") }}
            </div>

        </div>

    </div>
</template>

<script>

export default {
    props: {
        post: {
            type: Object
        }
    }, 
    computed: {
        cleanTitle: function() {
            return this.post.title.replace(/&#038;/, '&').replace(/&#8211;/, '').replace(/\<sup\>®\<\/sup\>/, '')
        }
    } 
}
</script>
